import React from 'react';
import '../ViewOrganizations.css';
import './MembersList.css';
import EmailIcon from '../../../../assets/LandingPage/Org/send-email-Black.svg';
import AcceptIconBtn from '../../../../assets/LandingPage/Org/AcceptIconBtn.svg';
import RejectIconBtn from '../../../../assets/LandingPage/Org/RejectIconBtn.svg';
import { organizationAPI } from '../../../../api/requests/organization/organizationAPI';
import ViewORgBtnIcon from '../../../../assets/LandingPage/Org/viewOrgWhiteIcon.svg';
import { handleAlert } from '../../../../utils/handleAlert';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { Button, Chip } from '@mui/material';

export default function MemberDetails({
  member,
  showEmail,
  inviteSent,
  inviteAccepted,
  inviteRejected,
  inviteReceived,
  UsedForInvitesSent,
  sendMail,
  organization,
  setSelectedOrgName,
  requestReceived,
  fetchRequests,
  fetchInvite,
  fetchMembers,
  invitesSentLoading,
  membersLoading,
  requestsReciveLoading,
}) {
  if (!member) {
    return null;
  }

  const renderProfilePhoto = () => {
    if (member.profilePhotoLink || member.user?.profilePhotoLink) {
      return (
        <img
          style={{ width: '40px', height: ' 40px' }}
          src={member?.profilePhotoLink || member.user?.profilePhotoLink}
          alt=""
          width={'40px'}
          height="auto"
        />
      );
    } else {
      const firstNameInitial =
        member?.firstName?.charAt(0) || member.user?.firstName?.charAt(0) || '';
      const lastNameInitial = member?.lastName?.charAt(0) || member.user?.lastName?.charAt(0) || '';

      return (
        <div className="initials-container">
          <span>{firstNameInitial}</span>
          <span>{lastNameInitial}</span>
        </div>
      );
    }
  };

  const renderProfilePhotoOrg = () => {
    if (member?.organization.logoLink) {
      return (
        <img
          style={{ width: '40px', height: ' 40px' }}
          src={member?.organization?.logoLink}
          alt=""
        />
      );
    } else {
      const firstNameInitial = member?.organization?.name?.charAt(0) || '';
      return (
        <div className="initials-container">
          <span>{firstNameInitial}</span>
        </div>
      );
    }
  };

  const renderProfilePhotoPending = () => {
    const firstNameInitial = member?.created_for?.charAt(0) || '';
    return (
      <div className="initials-container-pending">
        <span>{firstNameInitial}</span>
      </div>
    );
  };
  const acceptInvite = () => {
    organizationAPI
      .inviteAction(member.id, 'ACCEPT')
      .then(() => {
        handleAlert('Invite accepted successfully', 'success');
        fetchInvite();
      })
      .catch((error) => {
        handleAlert('Error accepting invite', 'error');
      });
  };

  const rejectInvite = () => {
    organizationAPI
      .inviteAction(member.id, 'REJECT')
      .then(() => {
        handleAlert('Invite rejected successfully', 'success');
        fetchInvite();
      })
      .catch((error) => {
        handleAlert('Error rejecting invite', 'error');
      });
  };
  const deleteInvite = () => {
    organizationAPI
      .inviteAction(member.id, 'DELETE')
      .then(() => {
        handleAlert('Invite deleted successfully', 'success');
        fetchInvite();
      })
      .catch((error) => {
        handleAlert('Error rejecting invite', 'error');
      });
  };
  const acceptRequest = () => {
    organizationAPI
      .requestAction(member.id, 'ACCEPT')
      .then(() => {
        handleAlert('Request accepted successfully', 'success');
        fetchRequests();
        fetchMembers();
      })
      .catch((error) => {
        handleAlert('Error accepting request', 'error');
      });
  };

  const rejectRequest = () => {
    organizationAPI
      .requestAction(member.id, 'REJECT')
      .then(() => {
        handleAlert('Request rejected successfully', 'success');
        fetchRequests();
      })
      .catch((error) => {
        handleAlert('Something went wrong, please try again later', 'error');
      });
  };

  const openView = (organizationName) => {
    setSelectedOrgName(organizationName);
  };

  return (
    <>
      {sendMail ? (
        <div className="viewSecondRow-orgDetailsMemberBlock-Email">
          <div className="viewSecondRow-orgDetailsMemberBlockDetsCont">
            <div className="viewSecondRow-orgDetailsMemberBlockDetsCont-Email">
              {renderProfilePhoto()}
              <div className="viewSecondRow-orgDetailsMemberBlockDets">
                <div className="member-name-container">
                  <p>{`${member?.firstName} ${member?.lastName}`}</p>
                </div>
                <span className="member-name-container">
                  {showEmail ? member?.Email : member?.username}
                </span>
              </div>
            </div>
            <div className="MembersList-ButtonsCont">
              <img src={EmailIcon} alt="" />
            </div>
          </div>
        </div>
      ) : UsedForInvitesSent ? (
        <div className="viewSecondRow-orgDetailsMemberBlock-Invite">
          <div className="viewSecondRow-orgDetailsMemberBlockDets-Email">
            <div className="pending-invite-name-email">
              {renderProfilePhotoPending()}
              <p>{showEmail ? member?.created_for : member?.username}</p>
            </div>
            <div className="pending-invite-status-cancelbtn">
              <Chip
                label={member?.status === 'SENT' ? 'Pending' : member?.status}
                variant='filled'
                color='info'
                sx={{
                  color: 'var(--color-text-secondary)'
                }}
              />
              <Button
                variant='outlined'
                color='error'
                onClick={() => deleteInvite()}
                disabled={invitesSentLoading}
                sx={{
                  opacity: invitesSentLoading ? 0.5 : 1,
                  cursor: invitesSentLoading ? 'not-allowed' : 'pointer',
                  height: '32px'
                }}
              >
                Cancel Invite
              </Button>
            </div>
          </div>
        </div>
      ) : organization ? (
        <div className="viewSecondRow-Notification">
          <div className="viewSecondRow-orgDetailsMemberBlock-PhotoUserName">
            {renderProfilePhotoOrg()}
            <div className="viewSecondRow-orgDetailsMemberBlockDets">
              <p>{member?.organization?.name}</p>
              <button
                className="ViewBtnNotification"
                style={{
                  borderRadius: '15px',
                  background: '#98AFFF',
                  border: 'none',
                  padding: '3px 10px',
                  color: 'white',
                  filter: ' drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.50))',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  marginTop: '5px',
                }}
                onClick={() => openView(member?.organization?.name)}
              >
                View Org
                <img src={ViewORgBtnIcon} style={{ width: '22px', height: 'auto' }} alt="" />
              </button>
            </div>
          </div>

          <div className="MembersList-ButtonsCont">
            {inviteSent ? (
              <button className="MembersList-AcceptedBtn">&#x2022; &nbsp;{member.status}</button>
            ) : inviteAccepted ? (
              <button className="MembersList-AcceptedBtn">&#x2022; &nbsp;Accepted</button>
            ) : inviteRejected ? (
              <button className="MembersList-RejectedBtn">&#x2022; &nbsp;Rejected</button>
            ) : inviteReceived ? (
              <div className="MembersList-inviteReceived">
                <button
                  className="MembersList-inviteReceived-Accept"
                  onClick={() => acceptInvite()}
                >
                  Accept <img src={AcceptIconBtn} alt="" />
                </button>
                <button
                  className="MembersList-inviteReceived-Reject"
                  onClick={() => rejectInvite()}
                >
                  Reject <img src={RejectIconBtn} alt="" />
                </button>
              </div>
            ) : requestReceived ? (
              <div className="MembersList-inviteReceived">
                <button
                  className="MembersList-inviteReceived-Accept"
                  onClick={() => acceptRequest()}
                >
                  Accept <img src={AcceptIconBtn} alt="" />
                </button>
                <button
                  className="MembersList-inviteReceived-Reject"
                  onClick={() => rejectRequest()}
                >
                  Reject <img src={RejectIconBtn} alt="" />
                </button>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className="viewSecondRow-orgDetailsMemberBlock">
          <div
            className="viewSecondRow-orgDetailsMemberBlock-PhotoUserName"
            style={{
              overflow: 'auto',
            }}
          >
            {renderProfilePhoto()}
            <div className="viewSecondRow-orgDetailsMemberBlockDets">
              <div className="member-name-container">
                <p className="member-name">
                  {`${member.user?.firstName || member?.firstName || ''} ${member.user?.lastName || member?.lastName || ''
                    }`}
                </p>
              </div>
              <div className="viewSecondRow-orgDetailsMemberBlockDetsSpan">
                <span
                  style={{
                    color: 'rgba(135, 135, 135, 1)',
                  }}
                >
                  {showEmail ? member.user?.Email : member.user?.username || member?.username}
                </span>
              </div>
            </div>
          </div>

          <div className="MembersList-ButtonsCont">
            {inviteSent ? (
              <button className="MembersList-AcceptedBtn">&#x2022; &nbsp;{member.status}</button>
            ) : inviteAccepted ? (
              <button className="MembersList-AcceptedBtn">&#x2022; &nbsp;Accepted</button>
            ) : inviteRejected ? (
              <button className="MembersList-RejectedBtn">&#x2022; &nbsp;Rejected</button>
            ) : inviteReceived ? (
              <div className="MembersList-inviteReceived">
                <button
                  className="MembersList-inviteReceived-Accept"
                  onClick={() => acceptInvite()}
                >
                  Accept <img src={AcceptIconBtn} alt="" />
                </button>
                <button
                  className="MembersList-inviteReceived-Reject"
                  onClick={() => rejectInvite()}
                >
                  Reject <img src={RejectIconBtn} alt="" />
                </button>
              </div>
            ) : requestReceived ? (
              <div className="MembersList-inviteReceived-blue">
                <button
                  className="MembersList-inviteReceived-Accept-blue"
                  onClick={() => acceptRequest()}
                >
                  Accept
                </button>

                <Tooltip title="Reject">
                  <IconButton
                    onClick={() => rejectRequest()}
                    sx={{
                      p: 0,
                      opacity: requestsReciveLoading ? 0.5 : 1,
                      cursor: requestsReciveLoading ? 'not-allowed' : 'pointer',
                    }}
                    disabled={requestsReciveLoading}
                  >
                    <DeleteIcon
                      sx={{
                        color: 'var(--color-text-secondary)',
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
}
